/**
 * SSO buttons, one per provider configured for this tenant.
 *
 * Renders nothing when no providers exist — an empty "or continue with" divider above
 * a blank space is worse than no divider at all.
 */

import { lmsOrigin } from '../../shared/lib/openedx';
import { absolute, type AuthProvider } from '../../shared/lib/providers';

export function ProviderButtons({
  providers,
  mode,
}: {
  providers: AuthProvider[];
  mode: 'login' | 'register';
}) {
  if (providers.length === 0) return null;

  return (
    <div className="auth__providers">
      <p className="auth__divider">
        <span>or continue with</span>
      </p>

      <div className="auth__provider-grid">
        {providers.map((provider) => (
          <a
            key={provider.id}
            className="auth__provider"
            href={absolute(mode === 'login' ? provider.loginUrl : provider.registerUrl, lmsOrigin)}
          >
            {provider.iconImage ? (
              <img src={absolute(provider.iconImage, lmsOrigin)} alt="" width={18} height={18} />
            ) : (
              <span className="auth__provider-dot" aria-hidden="true" />
            )}
            <span>{provider.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
